import React from 'react';
import { testimonialData } from '../data';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper'; // Correct import for Autoplay
import 'swiper/css';
import 'swiper/css/autoplay'; // Import CSS for autoplay
import { motion } from 'framer-motion';
import { fadeIn } from '../variants';

const Testimonial = () => {
  return (
    <motion.section
      variants={fadeIn('right')}
      initial="hidden"
      whileInView={'show'}
      viewport={{ once: false, amount: 0.2 }}
      className="py-[40px] lg:pb-[160px] lg:pt-0"
    >
      <div className="container mx-auto">
        {/* Swiper Component */}
        <Swiper
          modules={[Autoplay]} // Use correct Autoplay module import
          autoplay={{
            delay: 5000, // 5 seconds delay
            disableOnInteraction: false, // Resume autoplay after interaction
          }}
          loop={true} // Infinite loop
          onMouseEnter={(swiper) => swiper.autoplay.stop()} // Pause autoplay on hover
          onMouseLeave={(swiper) => swiper.autoplay.start()} // Resume autoplay on hover out
        >
          {testimonialData.map((slide, index) => {
            const { quoteImg, message, name, occupation } = slide;
            return (
              <SwiperSlide key={index}>
                <div className="max-w-[1100px] mx-auto flex flex-col items-center lg:flex-row lg:items-start gap-x-[38px] mt-1">
                  {/* Quote Image */}
                  <div className="w-[154px] h-[109px] mb-5">
                    <img src={quoteImg} alt="" />
                  </div>
                  {/* Testimonial Content */}
                  <div className="flex-1 lg:mt-[54px]">
                    <div className="text-xl lg:text-[25px] leading-normal mb-6 lg:mb-12">
                      {message}
                    </div>
                    <div className="flex items-center text-xl lg:text-2xl font-primary">
                      <div className="font-semibold">{name}</div>
                      <span className="mx-4">|</span>
                      <div className="font-light">{occupation}</div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </motion.section>
  );
};

export default Testimonial;